<!--
 * @Description: 完税证明上传
 * @Date: 2022-01-18 14:08:19
-->
<template>
  <el-dialog
    title="完税证明"
    :before-close="() => $emit('close')"
    :visible="true"
    width="900px"
    center
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
    >
      <el-row :gutter="20">
        <el-col style="margin-right:30px" :span="10">
          <el-form-item label="个体名称：" prop="individualId">
            <dic-select
              @dic-select-obj="dicSelectChange"
              placeholder="请选择个体"
              :fuzzyDef="searchAjax"
              :prop="{ label: 'businessRegisterName', code: 'id' }"
              ajaxQuery="keyWord"
              :defaultActive="defaultActive"
            ></dic-select>
          </el-form-item>
          <el-form-item label="征收品目：" prop="feeItemName">
            <el-input
              v-model="ruleForm.feeItemName"
              :maxLength="30"
              show-word-limit
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="完税证明附件：" prop="attachment">
            <el-dropdown @command="handleCommand">
              <el-button type="primary">
                选择文件上传方式
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu
                style="width:175px;text-align: center;"
                slot="dropdown"
              >
                <el-dropdown-item
                  :disabled="fileTypeSure === '.PNG,.JPEG,.JPG,.BMP'"
                  command=".PDF"
                >
                  PDF上传
                </el-dropdown-item>
                <el-dropdown-item
                  :disabled="fileTypeSure === '.PDF'"
                  command=".PNG,.JPEG,.JPG,.BMP"
                >
                  图片上传
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-upload
              class="upload-demo"
              ref="upload"
              action="/rest/cso/saas/upload/taxPaymentAtt"
              :multiple="true"
              :file-list="ruleForm.attachment"
              :on-success="
                (response, file, fileList) => {
                  changeFormVal(fileList, response.data.fileUrl, file);
                }
              "
              :on-exceed="uploadExc"
              :on-preview="handlePreview"
              :on-error="uploadError"
              :before-upload="beforeUpload"
              :on-remove="removeFormVal"
              :accept="fileTypeSure"
              :headers="headers"
              :limit="10"
              style="margin-right:40px;width:300px"
            >
              <el-button
                ref="telUpload"
                size="small"
                type="primary"
                style="display: none;"
              >
                选择文件
              </el-button>
              <div slot="tip" class="el-upload__tip">
                {{ `只能上传${fileTypeSure || 'PDF/图片'}文件` }}
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="征收项目：" prop="feeProjectName">
            <el-select v-model="ruleForm.feeProjectName">
              <el-option label="增值税" value="增值税"></el-option>
              <el-option label="个人所得税" value="个人所得税"></el-option>
              <el-option
                label="城市维护建设税"
                value="城市维护建设税"
              ></el-option>
              <el-option label="教育费附加" value="教育费附加"></el-option>
              <el-option label="地方教育附加" value="地方教育附加"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缴费状态：" prop="feeStatus">
            <el-select v-model="ruleForm.feeStatus">
              <el-option label="未缴费" :value="0"></el-option>
              <el-option label="已缴费" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dicSelect from '@C/Common/dicSelect';
import { taxPayment } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import Config from '@/config/index';

export default {
  components: {
    dicSelect
  },
  props: ['row', 'isEdit'],
  data() {
    return {
      searchAjax: taxPayment.selIndividualList,
      headers: {
        [Config.token]: getToken()
      },
      defaultActive: {
        enterpriseIdentifierName: '',
        id: ''
      },
      ruleForm: {
        attachment: [],
        individualId: '', //个体名称id
        feeItemName: '', //征收品目
        feeStatus: '', //缴费状态
        feeProjectName: '' //征收项目
      },
      rules: {
        attachment: [
          { required: true, message: '请选择完税证明附件', trigger: 'change' }
        ],
        individualId: [
          {
            required: true,
            message: '请选择个体',
            trigger: 'change'
          }
        ],
        feeItemName: [
          {
            required: true,
            message: '征收品目不能为空',
            trigger: 'change'
          }
        ],
        feeStatus: [
          {
            required: true,
            trigger: 'change',
            message: '缴费状态不能为空'
          }
        ],
        feeProjectName: [
          {
            required: true,
            message: '征收项目不能为空',
            trigger: 'blur'
          }
        ]
      },
      fileTypeRule: '',
      fileTypeSure: ''
    };
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const _ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          _ruleForm.attachment = _ruleForm.attachment.map(item => {
            return {
              attachmentName: item.name,
              attachmentType: { '.PNG,.JPEG,.JPG,.BMP': 1, '.PDF': 2 }[
                this.fileTypeSure
              ], //附件类型(1 图片  2 pdf)',
              attachmentUrl: item.url //附件url
            };
          });
          taxPayment
            .addTaxPayment({ ..._ruleForm, id: this.row && this.row.id })
            .then(() => {
              this.$emit('refresh');
              this.$emit('close');
            });
        }
      });
    },
    beforeUpload(file) {
      if (this.fileTypeRule === '.PDF') {
        //选择文件上传方式为pdf
        if (file.type !== 'application/pdf') {
          this.$message.error('请选择PDF文件');
          return false;
        }
      } else {
        //选择文件上传方式为img
        if (
          !['image/png', 'image/jpeg', 'image/jpg', 'image/bmp'].includes(
            file.type
          )
        ) {
          this.$message.error('请选择PNG,JPEG,JPG,BMP文件');
          return false;
        }
      }
      if (file.size > 50 * 1024 * 1024) {
        this.ruleForm.attachment = [];
        this.$message.error('上传文件需小于50M');
        return false;
      }
      //防止点取消
      this.fileTypeSure = this.fileTypeRule;
    },
    handleCommand(command) {
      this.fileTypeRule = command;
      //先选择了文件上传方式再触发input事件
      this.$nextTick(() => {
        this.beforeInput(command);
      });
    },
    changeFormVal(fileList, fileUrl, file) {
      this.ruleForm.attachment.push({
        url: fileUrl,
        uid: file.uid,
        name: file.name
      });
    },
    handlePreview(v) {
      const fileUrl = `${Config.fileViewUrl}?url=${v.url ||
        v.response.data.fileUrl}`;
      window.open(fileUrl);
    },
    dicSelectChange(v) {
      this.ruleForm.individualId = +v.id;
    },
    removeFormVal(file) {
      //删除文件用uid为标识
      this.ruleForm.attachment = this.ruleForm.attachment.filter(item => {
        return file.uid !== item.uid;
      });
    },
    beforeInput() {
      this.$refs.telUpload.$el.click();
    },
    uploadExc() {
      this.$message.error('不能继续上传,超出上限数量');
    },
    uploadError() {
      this.ruleForm.attachment = [];
      this.$message.error('上传失败,请重试');
    }
  },
  watch: {
    'ruleForm.attachment': {
      handler(v) {
        //没有文件时可以选文件类型
        if (v.length === 0) this.fileTypeSure = '';
      }
    }
  },
  created() {
    this.isEdit &&
      taxPayment.proofAttById({ id: this.row.id }).then(res => {
        const { pdata: data } = res;
        this.ruleForm.attachment = data.attachments.map(item => {
          //判断获取的文件类型
          const fileType =
            item.attachmentType === 2 ? '.PDF' : '.PNG,.JPEG,.JPG,.BMP';
          return {
            name: item.attachementName,
            url: item.attachmentUrl,
            attachmentType: fileType,
            uid: item.id
          };
        });
        this.fileTypeSure =
          this.ruleForm.attachment[0] &&
          this.ruleForm.attachment[0].attachmentType;
        this.defaultActive.enterpriseIdentifierName =
          data.enterpriseIdentifierName;
        this.defaultActive.id = data.userEnterpriseAgentId;
        this.ruleForm.individualId = data.userEnterpriseAgentId;
        this.ruleForm.feeItemName = data.feeItemName;
        this.ruleForm.feeStatus = data.feeStatus;
        this.ruleForm.feeProjectName = data.feeProjectName;
      });
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-date-editor--monthrange.el-input__inner {
    width: 230px;
  }
  .el-input__inner {
    width: 230px;
  }
}
</style>
